import DefaultLoader from './DefaultLoader';

export default DefaultLoader;
